export enum ScopePermissions {
	Read = "READ",
	ReadWrite = "READ/WRITE",
}

export enum AccountSettingsScope {
	PageAccess = "r:merchant.settings",
	MerchantEditAccess = "u:merchant.settings",
	InternalEditAccess = "u:merchant.internal_settings",
	ApiKeysAccess = "r:merchant.api",
	EmailNotificationSettingsReadAccess = "r:org.subscription",
	EmailNotificationSettingsEditAccess = "w:org.subscription",
	InternalSettingsAccess = "r:merchant.internal_settings",
	PaymentProductsAccess = "r:paymentProduct",
	CheckoutDesignAccess = "r:ui_customizations",
	CheckoutDesignEdit = "u:ui_customizations",
	BankInformationAccess = "r:bank_information",
	BankInformationEdit = "u:bank_information",
	PasswordChangeAccess = "w:user.password",
	FundingSettingsAccess = "r:funding_settings",
	FundingSettingsEdit = "u:funding_settings",
	PlacementSettingsAccess = "r:placements",
	PlacementSettingsEdit = "w:placements",
	LocationVerificationCodesAccess = "r:org.code",
	MerchantIdValidationAccess = "r:vc.restricted",
	CreateMerchantVirtualCardAccess = "c:vc.issuance",
}

export enum UserManagementScope {
	PageReadAccess = "r:merchant.users",
	PageWriteAccess = "w:merchant.users",
}

export enum CartScope {
	CreateCartAccess = "w:cart",
	ViewCartAccess = "r:cart",
	NotifyCartAccess = "u:cart",
	ExpireCartAccess = "u:cart",
	EditCartAccess = "u:cart",
}

export enum LocationsScope {
	ViewLocationsAccess = "r:merchant.location",
	UpdateLocationsAccess = "u:merchant",
}

export type GrantScope = AccountSettingsScope | UserManagementScope | CartScope | LocationsScope;

export const fakeAuthStorageKey = "adminToken";
export const oktaStorageKey = "okta-token-storage";
export const breadTokenStorageKey = "bread-token-storage";
export const selectedMerchantStorageKey = "selectedMerchantID";
export const userProgramsSelectionKey = "userProgramsSelection";
export const previousSelectedMerchantsStorageKey = "previousSelectedMerchants";
export const alertsStorageKey = "alerts";
export const classicPortalDismissedStorageKey = "classicPortalDismissed";
export const merchantChooserDropdownKey = "merchant-chooser-dropdown";
